import React, { useCallback } from 'react';
import { BagIcon } from '@sg/garnish';

import { useCart } from '@order/hooks';
import { useLocalizationContext } from '@order/Localization';

import { useOpenBag } from '../../../Bag/Bag.hooks';
import { FloatingButton } from '../FloatingButton';

// ─────────────────────────────────────────────────────────────────────────────

export const BagFloatingButton = () => {
  const { t } = useLocalizationContext();
  const { lineItemsCount, isCartEmpty } = useCart();
  const openBag = useOpenBag({ shouldUpdateCart: true });

  // ─────────────────────────────────────────────────────────────────────

  const BagIconWithCount = useCallback(
    () => <BagIcon bagCount={lineItemsCount} />,
    [lineItemsCount],
  );

  // ─────────────────────────────────────────────────────────────────────

  if (isCartEmpty) return null;

  return (
    <FloatingButton
      testID="bag.access"
      size="large"
      onPress={openBag}
      rightElement={BagIconWithCount}
    >
      {t('floating-buttons.bag.title')}
    </FloatingButton>
  );
};
